<template>
    <div class="modal-help" @click="onClose">
        <div class="modal-help-box">
            <div class="modal-help-title-box">Rule</div>
            <div class="modal-help-rule">
                <img
                    :src="imgurl1"
                    style="width: 5.8rem"
                    v-if="$store.state.temp.gameId != '4002'"
                />
                <img
                    :src="imgurl2"
                    style="width: 5.8rem"
                    v-if="$store.state.temp.gameId != '4002'"
                />
                <img
                    :src="imgurl3"
                    style="width: 5.8rem"
                    v-if="$store.state.temp.gameId == '4002'"
                />
            </div>
        </div>
    </div>
</template>
<script>
import tools from "../../utils/fun";
export default {
    name: "Modal",
    props: {},
    data() {
        return {
            imgurl1: "",
            imgurl2: "",
            imgurl3: "",
        };
    },
    mounted() {
        this.imgurl1 = tools.changeTowebp("/static/images/rules/chapter1.jpg");
        this.imgurl2 = tools.changeTowebp("/static/images/rules/chapter2.jpg");
        this.imgurl3 = tools.changeTowebp("/static/images/rules/chapter3.jpg");
    },
    methods: {
        onClose() {
            this.$emit("on-close");
        },
    },
};
</script>
<style>
.modal-help {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    /* align-items: center; */
    z-index: 9999;
}

.modal-help-box {
    background: #141415;
    background-size: 5.8rem 7.5rem;
    box-shadow: 0.02rem 0.02rem 0.2rem 0.01rem;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 0.05rem;
    -webkit-border-radius: 0.05rem;
    -moz-border-radius: 0.05rem;
    border-radius: 0.05rem;
    width: 5.8rem;
    height: 7.5rem;
    text-align: center;
}
.modal-help-title-box {
   
    height: 0.83rem;
    font-size: 0.36rem;
  background: rgba(76, 75, 75, 0.4);
    font-weight: bold;
    color: #d3d1d5;
    line-height: 0.83rem;
    text-align: center;
}
.modal-help-rule {
    padding-top: 20px;
    height: 650px;
    width: 580px;
    overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/common/rummy-help.vue